import { generateReadActionCreator } from 'actions/crudActionCreators';
import routes from 'actions/routes';
import ACTION_NAMES from 'actions/ACTION_NAMES';

export default {
    getContactRelations: generateReadActionCreator(routes.API_CONTACT_RELATIONS, ACTION_NAMES.CONTACT_RELATIONS, 'contact_relations')
}
